"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_dom_1 = require("react-router-dom");

var semantic_ui_react_1 = require("semantic-ui-react");

var data_1 = require("../data");

var SiteHeader =
/** @class */
function (_super) {
  __extends(SiteHeader, _super);

  function SiteHeader(props) {
    var _this = _super.call(this, props) || this;

    _this.renderNavMenu = function () {
      return React.createElement(semantic_ui_react_1.Menu, {
        defaultActiveIndex: -1,
        secondary: true
      }, React.createElement(semantic_ui_react_1.Menu.Item, {
        key: 'datasets'
      }, React.createElement(react_router_dom_1.Link, {
        to: '/dataset',
        style: {
          color: 'black',
          fontSize: '18px'
        }
      }, "datasets")), React.createElement(semantic_ui_react_1.Menu.Item, {
        key: 'visualizations'
      }, React.createElement(react_router_dom_1.Link, {
        to: '/visualizations',
        style: {
          color: 'black',
          fontSize: '18px'
        }
      }, "visualizations")), React.createElement(semantic_ui_react_1.Menu.Item, {
        key: 'stories'
      }, React.createElement(react_router_dom_1.Link, {
        to: '/stories',
        style: {
          color: 'black',
          fontSize: '18px'
        }
      }, "stories")));
    };

    _this.onMouseClick = function (e) {
      return;
    };

    _this.renderVisualizationsMenu = function () {
      return React.createElement(semantic_ui_react_1.Container, {
        fluid: true
      }, React.createElement(semantic_ui_react_1.Header, null, "Visualization applications"), React.createElement(semantic_ui_react_1.Divider, null), "dataset", React.createElement(semantic_ui_react_1.Divider, null), React.createElement(semantic_ui_react_1.Search, {
        defaultValue: 'search',
        icon: false
      }), React.createElement(semantic_ui_react_1.Table, {
        basic: 'very'
      }, React.createElement(semantic_ui_react_1.Table.Header, null, React.createElement(semantic_ui_react_1.Table.Row, null, React.createElement(semantic_ui_react_1.Table.HeaderCell, null, "Select"), React.createElement(semantic_ui_react_1.Table.HeaderCell, null, "Name"), React.createElement(semantic_ui_react_1.Table.HeaderCell, null, "Author(s)"), React.createElement(semantic_ui_react_1.Table.HeaderCell, null, "Last updated")), React.createElement(semantic_ui_react_1.Table.Row, {
        cells: [{
          key: 'Select',
          content: React.createElement(semantic_ui_react_1.Checkbox, {
            checked: true
          })
        }, {
          key: 'Name',
          content: 'SPRING'
        }, {
          key: 'Author',
          content: 'Weinreb, Wolock, Klein'
        }, {
          key: 'Last Updated',
          content: 'Nov 13, 2018'
        }]
      }), React.createElement(semantic_ui_react_1.Table.Row, {
        cells: [{
          key: 'Select',
          content: React.createElement(semantic_ui_react_1.Checkbox, {
            checked: false
          })
        }, {
          key: 'Name',
          content: 'tSNE-Tensor'
        }, {
          key: 'Author',
          content: '??'
        }, {
          key: 'Last Updated',
          content: 'Nov 13, 2018'
        }],
        style: {
          border: 'none'
        }
      }), React.createElement(semantic_ui_react_1.Table.Row, {
        cells: [{
          key: 'Select',
          content: React.createElement(semantic_ui_react_1.Checkbox, {
            checked: false
          })
        }, {
          key: 'Name',
          content: 'Anatomogram'
        }, {
          key: 'Author',
          content: '??'
        }, {
          key: 'Last Updated',
          content: 'Nov 13, 2018'
        }],
        style: {
          border: 'none'
        }
      }))));
    };

    _this.renderDatasetMenu = function () {
      var visualizations = [];

      if (_this.props.location) {
        var params = new URLSearchParams(_this.props.location.search);
        visualizations = params.getAll('viz').map(function (viz) {
          return "viz=" + viz;
        });
      }

      var datasets = ['hpc/full', 'hpc_sf2/full', 'tabula_muris/10k', 'tabula_muris/full', 'tabula_muris/lung'];
      var panes = [{
        menuItem: 'human cell atlas',
        render: function render() {
          return React.createElement(semantic_ui_react_1.Tab.Pane, null, React.createElement(semantic_ui_react_1.Container, {
            fluid: true
          }, React.createElement(semantic_ui_react_1.Table, {
            basic: 'very'
          }, React.createElement(semantic_ui_react_1.Table.Header, null, React.createElement(semantic_ui_react_1.Table.Row, null, React.createElement(semantic_ui_react_1.Table.HeaderCell, null, React.createElement(semantic_ui_react_1.Dropdown, {
            placeholder: 'search',
            selection: true
          })), React.createElement(semantic_ui_react_1.Table.HeaderCell, null, React.createElement(semantic_ui_react_1.Dropdown, {
            placeholder: 'organ',
            selection: true
          })), React.createElement(semantic_ui_react_1.Table.HeaderCell, null, React.createElement(semantic_ui_react_1.Dropdown, {
            placeholder: 'method',
            selection: true
          })))))));
        }
      }, {
        menuItem: 'HCA Dynamics public',
        render: function render() {
          return React.createElement(semantic_ui_react_1.List, null, datasets.map(function (dataset, index) {
            return _this.renderDatasetLinkItem(dataset, index, visualizations);
          }));
        }
      }, {
        menuItem: 'upload from computer',
        render: function render() {
          return React.createElement(semantic_ui_react_1.Tab.Pane, null, "Coming soon!");
        }
      }];
      return React.createElement(semantic_ui_react_1.Container, {
        fluid: true
      }, React.createElement(semantic_ui_react_1.Header, null, "datasets"), React.createElement(semantic_ui_react_1.Divider, null), React.createElement(semantic_ui_react_1.Tab, {
        defaultActiveIndex: 1,
        menu: {
          secondary: true,
          pointing: true
        },
        panes: panes
      }));
    };

    _this.renderDatasetLinkItem = function (datasetName, index, visualizations) {
      return React.createElement(semantic_ui_react_1.List.Item, {
        key: "dataset-link-" + index
      }, React.createElement(react_router_dom_1.Link, {
        onClick: _this.closeModal,
        to: {
          pathname: '/dataset',
          search: "?name=" + datasetName + "&" + visualizations.join('&')
        }
      }, datasetName));
    };

    _this.closeModal = function () {
      _this.setState({
        isModalOpen: false
      });
    };

    _this.openModal = function (event, data) {
      _this.setState({
        isModalOpen: true
      });
    };

    _this.state = {
      currentPageName: null,
      isModalOpen: false
    };
    return _this;
  }

  SiteHeader.prototype.componentDidMount = function () {
    window.addEventListener('click', this.onMouseClick);

    if (this.props.location) {
      this.handleQueryParams(this.props.location.search);
    }
  };

  SiteHeader.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.location && this.props.location !== prevProps.location) {
      this.handleQueryParams(this.props.location.search);
    }
  };

  SiteHeader.prototype.componentWillUnmount = function () {
    window.removeEventListener('click', this.onMouseClick);
  };

  SiteHeader.prototype.render = function () {
    return React.createElement(semantic_ui_react_1.Header, null, React.createElement(semantic_ui_react_1.Menu, {
      secondary: true,
      borderless: true,
      fluid: true,
      style: {
        maxHeight: '40px',
        padding: '20px 0 0 0'
      }
    }, React.createElement(semantic_ui_react_1.Menu.Item, {
      fitted: 'vertically',
      position: 'left'
    }, React.createElement(react_router_dom_1.Link, {
      to: '/'
    }, React.createElement("img", {
      alt: 'hca-dynamics-icon',
      src: 'assets/icons/bio-blocks-icon-2x.png',
      style: {
        height: '32px',
        width: '32px'
      }
    }), React.createElement("span", {
      style: {
        color: 'black',
        fontSize: '32px',
        fontWeight: 'bold'
      }
    }, "HCA Dynamics"))), this.renderNavMenu(), React.createElement(semantic_ui_react_1.Menu.Item, {
      position: 'right'
    }, React.createElement(semantic_ui_react_1.Input, {
      icon: 'search',
      size: 'massive',
      transparent: true
    }))), this.renderNavBreadcrumb(), this.renderCurrentData());
  };

  SiteHeader.prototype.renderCurrentData = function () {
    var location = this.props.location;

    if (location) {
      var params = new URLSearchParams(location.search);
      var visualizations = params.getAll('viz'); // tslint:disable-next-line:no-backbone-get-set-outside-model

      var name_1 = params.get('name');
      return name_1 && data_1.DatasetData[name_1] && React.createElement(semantic_ui_react_1.Grid, {
        centered: true,
        padded: true,
        textAlign: 'center'
      }, React.createElement(semantic_ui_react_1.Grid.Row, {
        textAlign: 'left'
      }, React.createElement("p", null, "Selected visualization(s): ", React.createElement("span", {
        style: {
          fontWeight: 'normal'
        }
      }, visualizations.map(function (viz) {
        return data_1.VizData[viz].name;
      }).join(', ')), React.createElement("br", null), name_1 && "Selected dataset: ", React.createElement("span", {
        style: {
          fontWeight: 'normal'
        }
      }, data_1.DatasetData[name_1].fullName + " (" + name_1 + ")"))));
    } else {
      return null;
    }
  };

  SiteHeader.prototype.renderNavBreadcrumb = function () {
    return React.createElement(semantic_ui_react_1.Breadcrumb, {
      style: {
        padding: '0 0 0 40px'
      }
    }, React.createElement(semantic_ui_react_1.Breadcrumb.Section, null, React.createElement(react_router_dom_1.Link, {
      to: '/'
    }, "home")), this.props.location && this.props.location.pathname.split('/').filter(function (candidatePath) {
      return candidatePath.length >= 1;
    }).map(function (path, index) {
      return React.createElement(React.Fragment, {
        key: "breadcrumb-" + index
      }, React.createElement(semantic_ui_react_1.Breadcrumb.Divider, {
        icon: 'right angle'
      }), React.createElement(semantic_ui_react_1.Breadcrumb.Section, null, React.createElement(react_router_dom_1.Link, {
        to: "/" + path
      }, path)));
    }), this.state.currentPageName && React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Breadcrumb.Divider, {
      icon: 'right angle'
    }), React.createElement(semantic_ui_react_1.Breadcrumb.Section, null, this.state.currentPageName)));
  };

  SiteHeader.prototype.handleQueryParams = function (search) {
    var params = new URLSearchParams(search);
    var visualizations = params.getAll('viz'); // tslint:disable-next-line:no-backbone-get-set-outside-model

    var name = params.get('name');

    if (visualizations.length >= 1 && !name) {
      this.setState({
        currentPageName: name,
        isModalOpen: true
      });
    } else {
      this.setState({
        currentPageName: name,
        isModalOpen: false
      });
    }
  };

  return SiteHeader;
}(React.Component);

exports.SiteHeader = SiteHeader;